export const en_strings = {
  AtlantikTurs: 'Atlantik turs',
  home: 'Home',
  clients: 'Clients',
  excursions: 'Excursions',
  loggedInAs: 'Logged in as: ',
  logout: 'Logout',
  Skopje: 'Skopje',
  phoneFax: 'phone/fax',
  email: 'Е-mail',
  Kavadarci: 'Kavadarci',
  welcomeNote: 'Welcome to Atlantik Turs Management Portal',
  slogan: 'Empowering your travel agency with seamless management tools, tailored to simplify your daily operations and enhance productivity.',
  whatWeDeliver: 'What We Deliver!',
  efficientClientManagement: 'Efficient Client Management',
  efficientClientManagementSlogan: 'Easily handle client profiles, bookings, and communications.',
  comprehensiveAnalytics: 'Comprehensive Analytics',
  comprehensiveAnalyticsSlogan: 'Access detailed reports to make informed decisions.',
  taskAutomation: 'Task Automation',
  taskAutomationSlogan: 'Automate repetitive tasks to save time and resources.',
  accessDenied: 'Access denied...',
  notAllowed: 'You are not allowed on this page!',
  goBack: 'Go back',
  search: 'Search',
  name: 'Name',
  surname: 'Surname',
  dateOfBirth: 'Date of birth',
  phoneNumber: 'Phone number',
  passportNumber: 'Passport number',
  identityCard: 'Identity card',
  points: 'Points',
  loyaltyStatus: 'Loyalty status',
  address: 'Address',
  ascending: 'Ascending',
  descending: 'Descending',
  sort: 'Sort',
  paginationSize: 'Pagination size: ',
  export: 'Export',
  exportFailed: 'Export Failed',
  failedToExport: 'Failed to export clients list.',
  exportSuccessful: 'Export Successful',
  addNewClient: 'Add new client',
  actions: 'Actions',
  noClients: 'There are no clients',
  previous: 'Previous',
  next: 'Next',
  excursionHistory: 'Excursion History',
  loadingExcursions: 'Loading excursions...',
  details: 'Details',
  excursionName: 'Excursion name',
  excursionPrice: 'Excursion price',
  excursionDiscount: 'Excursion discount',
  additionalDiscount: 'Additional discount',
  pointsUsed: 'Points used',
  pointsGained: 'Points gained',
  extraExpenses: 'Extra expenses',
  finalPrice: 'Final price',
  paidPrice: 'Paid price',
  submit: 'Submit',
  cancel: 'Cancel',
  page: 'page',
  of: 'of',
  clientDeletedSuccessfully: "Client deleted successfully",
  somethingWentWrong: 'Something went wrong',
  confirmationDelete: 'Do you really want to delete this item?',
  addClient: 'Add client',
  updateClient: 'Update client',
  successfullyAddedClient: 'Client added successfully!',
  successfullyUpdatedClient: 'Client updated successfully',
  clientDetails: 'Client Details',
  missingEorC: 'Missing excursion or client!',
  successfullyAddedExcursion: 'Excursion added successfully!',
  successfullyUpdatedExcursion: 'Excursion updated successfully!',
  excursionDeletedSuccessfully: 'Excursion deleted successfully!',
  addNewExcursion: 'Add new excursion',
  selectExcursion: 'Select Excursion',
  updateExcursion: 'Update excursion',
  addExcursion: 'Add excursion',
  excursion: 'Excursion',
  discount: 'Discount',
  travelingDocument: 'Traveling Document',
  startingPoint: 'Starting Point',
  usePoints: 'Use Points',
  note: 'Note',
  confirmedReservation: 'Confirmed reservation',
  totalPrice: 'Total price',
  requiredField: 'The field is required',
  signIn: 'Sign In',
  projectName: 'Project Name',
  payments: 'Payments',
  successfullyUpdatedPayment: 'Payment updated successfully!',
  paymentDeletedSuccessfully: "Payment deleted successfully!",
  successfullyAddedPayment: 'Payment added successfully!',
  excursionId: 'Excursion Id',
  placeTo: 'Place to',
  dateFrom: 'Date from',
  dateTo: 'Date to',
  price: 'Price',
  totalSeats: 'Total seats',
  bookedSeats: 'Booked seats',
  clientName: 'Client Name',
  clientSurname: 'Client Surname',
  addPayment: 'Add payment',
  paymentDate: 'Payment date',
  amount: 'Amount',
  selectDate: 'Select date',
  enterAmount: 'Enter amount',
  paymentHistory: 'Payment history',
  deletedSuccessfully: 'Deleted successfully',
  travelList: 'Travel list for excursion: ',
  noDetailsForExcursion: 'There are no details for this excursion!',
  noExcursions: 'There are no excursions!',
  noExcursionsForClient: 'There are no excursions for this client!',
  noPaymentHistory: 'No payment history available!',
  successfullyUpdatedDetails: 'Details updated successfully!',
  noData: 'No data',
  seatNumber: 'Seat number',
  employees: 'Employees',
  addEmployee: 'Add employee',
  editEmployee: 'Edit employee',
  username: 'Username',
  role: 'Role',
  password: 'Password',
  employeeDeletedSuccessfully: 'Employee deleted successfully',
  passwordChange: 'Change password',
  currentPassword: 'Current password',
  newPassword: 'New password',
  confirmPassword: 'Confirmed password',
  login: 'Login',
  loginMessage: 'Please login to your account',
  backToMainPage: 'Back to the main page',
  loggingIn: 'Logging in...',
  loginFailed: 'Login failed. Please check your credentials.',
  employeeAddedSuccessfully: 'Employee added successfully',
  employeeUpdatedSuccessfully: 'Employee updated successfully',
  error: 'Error',
  fullExport: 'Total export',
  uniqueMessage: 'Username and email must be unique',
};
